import { DivSorting, LabelSort } from './styles';
import { TSort } from '../../../../commonTypes/filters';
import React, { FC } from 'react';
import FnDropdown from '../../../../components/elements/FnDropdown/index';

type TProps = {
  onSortChange: (data: TSort) => void;
  sortItems: TSort[];
  currentSortItem: TSort;
};

export const Sorting: FC<TProps> = ({ onSortChange, sortItems, currentSortItem }) => {
  const handleChange = (sortItem: string) => {
    const newSortItem = sortItems?.find((el: TSort) => el.displayName === sortItem);
    onSortChange(newSortItem);
  };

  return (
    <>
      {!!sortItems.length && (
        <DivSorting>
          <LabelSort>Sort by</LabelSort>
          <FnDropdown
            propertyValue="displayName"
            propertyLabel="displayName"
            value={currentSortItem ? currentSortItem.displayName : sortItems[0].displayName}
            options={sortItems}
            onChange={handleChange}
          />
        </DivSorting>
      )}
    </>
  );
};
